import { Center, CenterProps, Spinner, SpinnerProps } from '@chakra-ui/react'

type Props = CenterProps & {
  size?: SpinnerProps['size']
}

export const Loading: React.FC<Props> = ({ size, ...props }) => {
  return (
    <Center {...props} py={6}>
      <Spinner color="blue.500" size={size} thickness={'3px'} />
    </Center>
  )
}

Loading.defaultProps = {
  size: 'lg',
}

type FullScreenLoadingOverlayProps = {
  label: string
}

export const FullScreenLoadingOverlay: React.FC<FullScreenLoadingOverlayProps> = ({ label }) => (
  <Center position="fixed" inset={0} zIndex="modal" bg="rgba(255, 255, 255, 0.55)" role="status" aria-label={label}>
    <Spinner color="blue.600" size="xl" thickness="4px" />
  </Center>
)
